export const CustomerVehicleCreateSceneTranslation = {
  fi: {
    CustomerVehicleCreateScene: {
      addVehicle: 'Lisää ajoneuvo',
      createSuccess: 'Ajoneuvo lisättiin asiakasyritykselle.',
      notSavedCheckFields: 'Ajoneuvoa ei tallennettu. Tarkista kentät.',
    },
  },
};
